<script setup lang="ts">
import GridRows from '@/composables/GridRows.vue'
</script>

<template>
  <div class="w-full flex items-center justify-center mobile-container">
    <!-- Main container - flex column reverse layout -->
    <div class="w-full sm:w-auto shadow-xl bg-white overflow-hidden">
      <GridRows overrideHeight :setMinClasses="true">
        <template #body>
          <div
            class="flex items-center justify-center bg-base-100/95 w-full h-full"
            aria-busy="true"
            role="status"
          >
            <div class="text-center px-4">
              <div class="loading loading-spinner loading-lg mb-4 text-primary" />
              <div class="text-xl font-semibold text-base-content">Signing out…</div>
            </div>
          </div>
        </template>
      </GridRows>
    </div>
  </div>
</template>
